import { Component, OnInit, ViewChild, OnDestroy, TemplateRef, AfterViewInit, computed, effect } from '@angular/core';
import { Router, RoutesRecognized } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';

import { filter, pairwise } from 'rxjs/operators';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from 'sweetalert2';

import { ApiResponseModel } from 'app/_models/apiResponseModel';
import { Globals } from 'app/_models/globals';
import { LocalStorageUtils } from 'app/_utils/localstorage';
import { NewFeaturesGetRoles, NewFeaturesGetShouldShowBanner } from '../_models/new-features-model';
import { NotificationQuotation } from 'app/_models/notificationQuotation';
import { RolesIdsEnum } from 'app/_models/roles';
import { SweetAlertParams } from 'app/_models/notificationParams.model';
import { Update } from 'app/_models/update';

import { getScreenSizeIsMobile, removeHTMLTags } from 'app/_utils/general-utils';

import { AccountService } from 'app/account/account.service';
import { BaseService } from 'app/_services/base.service';
import { PartsfyNotificationService } from '../_services/partsfy-notification.service';
import { GeneralService } from 'app/_services/general.service';
import { NewFeatureService } from './new-features.service';
import { NotificationService } from 'app/_services/notification.service';
import { SettingsService } from 'app/_services/settings.service';
import { UserValidationModalComponent } from './_components/user-validation-modal/user-validation-modal.component';
import { UserValidation } from '../_models/user-validation-model';
import { UserValidationService } from './user-validation.service';
import { CookiesManagementModalComponent } from './_components/cookies-management-modal/cookies-management-modal.component';
import { CookiesManagementService } from './cookies-management.service';
import { ScriptService } from 'app/_services/script.service';
import { MixPanelEventEnum } from 'app/_models/mixPanelEventEnum';
import { GeneralSignalRService } from './general.signalr.service';
import { Subscription } from 'rxjs';
import { UserService } from 'app/_services/user.service';
import { MixPanelService } from 'app/_services/mix-panel.service';
import { environment } from '../../../environments/environment';

declare var $: any;
declare const crisp: any;
declare const pliq: any;
declare const formatDateToDDMMYYYY: any;
declare const getJavascriptDateFromCSharpDate: any;
declare const isEmpty: any;
declare const numberToReal: any;
declare const waitForElm: any;

@Component({
    selector: 'app-master-page', templateUrl: './master-page.component.html', styleUrls: ['./master-page.component.scss'],
    standalone: false
})
export class MasterPageComponent implements AfterViewInit, OnInit, OnDestroy {
    @ViewChild('templateNovidades') templateNovidades: TemplateRef<any>;
    @ViewChild('templateUserValidationModal') public userValidationModal: UserValidationModalComponent;
    @ViewChild('templateCookiesManagementModal') public cookiesManagementModal: CookiesManagementModalComponent;
    modalRef: BsModalRef;

    private subscriptionDeslogarUsuarioEvent: Subscription;
    isLoggingOut: boolean = false;

    private localStorageUtils = new LocalStorageUtils();
    private subscriptionNotificationsListaNaoLidas;
    private subscriptionNotificationList;

    previousUrl: string;
    p_user_id: string;
    chatListUnreadCrispMessages: number = 0;
    currentNotificationList: NotificationQuotation[];
    newFeatures: Update[] = [];
    notificationListUnreadMessages: number = 0;
    totalNewFeatures: number;
    needsCookieConsent: boolean = false;
    loadAcceptAllCookies: boolean = false;

    isEmpty: any;
    pageIsMenuSuperiorFilter: any = { isHeaderMenu: true, isHidden: false };

    Swal: any;

    removeHTMLTags: any = removeHTMLTags;

    showCashback = computed(() => {
        const user = this.userService.user();

        if (this.generalService.hideMultiloginDropDown() || !user || isEmpty(user.cashback) || user.cashback.availableCashback <= 0)
            return false;

        return ((user.role === RolesIdsEnum.Comprador || user.role === RolesIdsEnum.DonoDaOficina) && !user.isAdmin) || this.userService.userIsCentral();
    })

    showNotification = computed(() => {
        const user = this.userService.user();

        if (!user)
            return false

        return (user.role === RolesIdsEnum.Comprador && !user.isAdmin) || this.userService.userIsCentral();
    })

    userMenu = computed(() => {
        const user = this.userService.user();

        if (isEmpty(user) || isEmpty(user.pages))
            return [];

        return user.pages.filter(p => !p.isHeaderMenu && !this.removerDevidoPropriedadeExcludente(p.hideProperty));
    })

    constructor(
        public accountService: AccountService,
        public userService: UserService,
        public baseService: BaseService,
        public partsfyNotificationService: PartsfyNotificationService,
        public generalService: GeneralService,
        private mixPanelService: MixPanelService,
        private newFeatureService: NewFeatureService,
        private notificationService: NotificationService,
        private settingsService: SettingsService,
        private generalSignalRService: GeneralSignalRService,
        private userValidationService: UserValidationService,
        private cookiesManagementService: CookiesManagementService,
        private globals: Globals,
        private sanitizer: DomSanitizer,
        private ngxLoader: NgxUiLoaderService,
        private modalService: BsModalService,
        private router: Router,
        private script: ScriptService) {
            this.router.events
                .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
                .subscribe((events: RoutesRecognized[]) =>
                {
                    this.previousUrl = events[0].urlAfterRedirects;
                });

                const effectRef = effect(() => {
                    if(this.userService.user()?.dadosMultiUsuario) {
                        this.setMultiLoginDropDown();
                        effectRef.destroy();
                    }
                }, { manualCleanup: true });
        }

    ngOnInit() {
        this.registerObservables();

        this.Swal = require('sweetalert2');

        const setCrispUnreadMessages = function (scope, total) {
            scope.chatListUnreadCrispMessages = total;
        }

        if (environment.enablePliq) {
            setTimeout(() => pliq.connect({ scope: this }));
        }

        crisp.connect({ scope: this, user: this.userService.user(), callback: function (scope, total) { setCrispUnreadMessages(scope, total); } });

        if (this.userService.user())
            this.criarNotificacoes();

        this.setCrispNickName();
        this.setFirstAccess();

        this.getNeedsCookieConsent();
    }

    ngOnDestroy() {
        try {
            this.subscriptionDeslogarUsuarioEvent.unsubscribe();
            this.subscriptionNotificationsListaNaoLidas.unsubscribe();
            this.subscriptionNotificationList.unsubscribe();
        } catch (e) { }
    }

    ngAfterViewInit(): void {
        this.handleUsersVerificationOpen()
    }

    abrirCashback() {
        if (this.userService.userIsCentral() || !this.userService.user().cashback.hasOwner)
            return this.router.navigate(['/comprador/cashback'], { queryParams: {} });

        if (this.userService.user().role === RolesIdsEnum.DonoDaOficina)
            return this.router.navigate(['/gestor-comprador/cashback'], { queryParams: {} });

        let pode_sacar = this.userService.user().cashback.availableCashback >= this.userService.user().cashback.minimunWithdraw;
        let valor_disponivel = numberToReal(this.userService.user().cashback.availableCashback);
        let data_limite = formatDateToDDMMYYYY(getJavascriptDateFromCSharpDate(this.userService.user().cashback.nextExpirationDate));

        let html = "<div class='col-md-12 text-start cashback" + (!pode_sacar ? ' mt10' : '') + "'>";
        html += "<fieldset class='mb0 pb0'>";
        html += "<legend>";
        html += this.globals.translate('buyer.cashback.modal.legend.disponivel') + ": <b>" + valor_disponivel + "</b>"

        if (!pode_sacar) {
            let minimunWithdraw = numberToReal(this.userService.user().cashback.minimunWithdraw);
            html += "<br />";
            html += "<small>";
            html += this.globals.translate('buyer.cashback.modal.legend.minimo-saque') + ": <b class='text-danger'>" + minimunWithdraw + "</b>";
            html += "</small>";
        }

        html += "</legend>";
        html += "<hr />";

        if (pode_sacar) {
            html += "<div class='mb10'>" + this.globals.translate('buyer.cashback.modal.corpo.somente-gestor') + "</div>";
            html += "<div><b>" + this.globals.translate('buyer.cashback.modal.corpo.gestor') + ":</b> " + this.userService.user().cashback.ownerName + "</div>";
            html += "<div><b>" + this.globals.translate('buyer.cashback.modal.corpo.email') + ":</b> " + this.userService.user().cashback.ownerEmail + "</div>";
        } else {
            html += "<div class='mb10'>" + this.globals.translate('buyer.cashback.modal.corpo.realize-compras') + "</div>";
        }

        html += "<hr />";
        html += "<div class='text-center'><small>" + this.globals.translate('buyer.cashback.modal.corpo.duvidas') + "</small></div>";
        html += "</fieldset>";
        html += "</div>";

        const params: SweetAlertParams = {
            title: this.globals.translate('buyer.cashback.modal.titulo') + data_limite,
            notTranslateTitle: true,
            message: html,
            isHtml: true,
            icon: pode_sacar ? 'success' : 'warning',
            confirmButtonText: 'elemento.generico-botao.fechar'
        }

        this.notificationService.showInfo(params)
    }

    acceptCookies(acceptedCookies: number) {
        this.needsCookieConsent = false;
        this.script.createGoogleAnalyticsScript(acceptedCookies);
    }

    acceptAllCookies() {
        this.loadAcceptAllCookies = true;

        this.cookiesManagementService.saveUserCookieConsentAcceptAll().subscribe({
            next: (response: ApiResponseModel<{ acceptedCookies: number }>) => {
                this.acceptCookies(response.result.acceptedCookies);

                this.loadAcceptAllCookies = false;
                this.notificationService.showSuccessToastr('geral.cookie-management.messages.success.accept-all', { translateMessage: true });
            },
            error: () => {
                this.needsCookieConsent = true;
                this.loadAcceptAllCookies = false;
                this.notificationService.showErrorToastr('geral.cookie-management.messages.error.accept-all', { translateMessage: true });
            }
        })
    }

    changeOfRoutes() {
        setTimeout(() => {
            this.generalService.hideMultiloginDropDown.set(false);
        });

        if (this.userService.userIsSupport() || getScreenSizeIsMobile())
            return;

        this.newFeatureService.getShouldShowBanner().subscribe({
            next: (response: ApiResponseModel<NewFeaturesGetShouldShowBanner>) => {
                if(response.result.features.length > 0) {
                    this.newFeatures = response.result.features;
                    this.newFeatures = this.setSafeHtmlUpdate(this.newFeatures);
                    this.newFeatures = this.newFeatures.filter(nf => nf.bugs_info_display !== '' || nf.features_info_display !== '')
                    this.totalNewFeatures = response.result.totalFeatures;

                    let shouldShowUpdates = response.result.shouldShowBanner && this.router.url.indexOf('/pedido/') < 0;

                    if (shouldShowUpdates)
                        $(".new-features").slideDown(200);
                }
            }
        })
    }

    criarNotificacoes() {
        // Se inscreve nos observables das notificações
        this.subscriptionNotificationsListaNaoLidas = this.partsfyNotificationService.totalMensagensNaoLidas.subscribe(tm => {
            this.notificationListUnreadMessages = tm;
        });

        this.subscriptionNotificationList = this.partsfyNotificationService.notificationList.subscribe(nl => {
            this.currentNotificationList = nl;

            if (!isEmpty(this.currentNotificationList)) {
                let totalMsgsNaoLidas = this.currentNotificationList.filter(n => n.status_id === 0).length;
                this.partsfyNotificationService.atualizarTotalMsgsNaoLidas();
                this.notificationListUnreadMessages = totalMsgsNaoLidas;
            }
        });
    }

    crispAbrir() {
        crisp.openWindow(`${this.userService.user().current_company_name} (${this.userService.user().name})`);
    }

    efetuarLogout() {
        this.accountService.logout();

        try { crisp.disconnect(); } catch (e) { console.log(e) }
        
        if (environment.enablePliq) {
            try { pliq.disconnect(); } catch (e) { console.log(e) }
        }
    }

    getNeedsCookieConsent() {
        this.cookiesManagementService.getUserCookieConsent().subscribe({
            next: (response: ApiResponseModel<{ acceptedCookies: number } | null>) => {
                this.needsCookieConsent = response.result == null;

                if (!this.needsCookieConsent) {
                    this.script.createGoogleAnalyticsScript(response.result.acceptedCookies);
                }
            }
        })
    }

    handleUsersVerificationOpen() {
        if (!this.userValidationService.enableUserVerification)
            return;

        this.userValidationService.getUser().subscribe({
            next: (response: ApiResponseModel<UserValidation>) => {
                this.userValidationModal.open(response.result);
            }
        })
    }

    loadMoreNewFeatures() {
        this.ngxLoader.startLoader('loader-new-features');
        this.newFeatureService.getUpdatesList(this.newFeatures.length, 3).subscribe({
            next: (response: ApiResponseModel<NewFeaturesGetRoles>) =>
            {
                let loadedFeatures = this.setSafeHtmlUpdate(response.result.features);
                this.newFeatures = this.newFeatures.concat(loadedFeatures);
                this.totalNewFeatures = response.result.totalFeatures;
                this.ngxLoader.stopLoader('loader-new-features');
            },
            error: () => {
                this.notificationService.showErrorToastr(this.globals.translate('geral.novidades.erro.carregar-mais.corpo'));
                this.ngxLoader.stopLoader('loader-new-features');
            }
        })
    }

    obterNomeSubTela(url, urlSubTela)
    {
        if (!url)
            return "";

        if (!urlSubTela)
            return 'geral.menu.' + url.replace('/', '.') + '.titulo';

        return 'geral.menu.' + url.replace('/', '.') + '.' + urlSubTela.replace('/', '.');
    }

    obterNomeTela(url)
    {
        if (!url)
            return "";

        return 'geral.menu.' + url.replace('/', '.');
    }

    newFeaturesClose()
    {
        $(".new-features").slideUp(200);
    }

    newFeaturesCloseModal() {
        this.modalRef.hide();
    }

    newFeaturesOpenModal() {
        let options: ModalOptions = { backdrop: 'static', class: 'new-features-modal gray', keyboard: false };
        this.modalRef = this.modalService.show(this.templateNovidades, options);

        if (this.newFeatures.length > 0)
            this.newFeatureService.setLastNewFeatureSeenDate().subscribe();

        this.newFeaturesClose()
    }

    openCookiePolicy() {
        const url = this.router.serializeUrl(this.router.createUrlTree([`/documentos/politica-cookies/plataforma`]));
        window.open(url, "_blank");
    }

    setCrispNickName() {
        let usuario = this.userService.user();

        if (usuario) {
            const isSeller = [4, 8, 16].includes(usuario.role);

            if (isSeller) {
                this.generalService.getCrispNickname().subscribe({
                    next: (response: ApiResponseModel<string>) => {
                        crisp.setUserNickname(response.result);
                    }
                });
            }
        }
    }

    setFirstAccess() {
        let hasUserAlreadyAccessed = this.localStorageUtils.getHasUserAlreadyAccessedByDay(this.userService.user());

        if (hasUserAlreadyAccessed)
            return

        this.mixPanelService.trackMixPanelEvent(MixPanelEventEnum.FirstAccessOfTheDay).subscribe({
            next: () => {
                this.localStorageUtils.saveHasUserAlreadyAccessedByDayData(this.userService.user());
            },
            error: (e: any) =>
                console.error(e)
        });
    }

    setMultiLoginDropDown() {
        waitForElm('.multi-usuario').then(() => {
            $('.multi-usuario').select2({ language: "pt-BR" });

            const global = this;

            $('.multi-usuario').on('select2:select', function (e) {
                Swal.close();
                $('.multi-usuario').attr('disabled', 'disabled');
                $('.multi-usuario').off('select2:select');
                global.trocarUsuario(global);
            });

            $(document).on('select2:open', () => { $('.select2-search__field').focus().select(); });
        });
    }

    handleNewFeaturesImages(feature_data: string) {
        var skipToGetSrc = 10;
        var regex = /<img src/gi;
        var result, src, srcStartIndex, srcEndIndex;
        var stringToAdd = "";

        while ((result = regex.exec(feature_data))) {
            srcStartIndex = result.index + skipToGetSrc
            srcEndIndex = feature_data.substring(srcStartIndex).search('"') + srcStartIndex
            src = feature_data.substring(srcStartIndex, srcEndIndex)
            stringToAdd += "<a target='_blank' href='" + src + "'>Abrir imagem</a><br><img  "
            feature_data = feature_data.substring(0, result.index) + stringToAdd + feature_data.substring(result.index + 5)

            //Garante que a segunda aparição de imagem não quebre o texto
            stringToAdd = "<br><br>"
        }

        return feature_data;
    }

    setSafeHtmlUpdate(updates: Update[]): Update[] {
        updates.forEach((feature: Update) => {
            feature.features_info = this.handleNewFeaturesImages(feature.features_info)
            feature.bugs_info = this.handleNewFeaturesImages(feature.bugs_info)

            feature.features_info_display = this.removeHTMLTags(feature.features_info) == '' ? '' : this.sanitizer.bypassSecurityTrustHtml(feature.features_info)
            feature.bugs_info_display = this.removeHTMLTags(feature.bugs_info) == '' ? '' : this.sanitizer.bypassSecurityTrustHtml(feature.bugs_info)
        });

        return updates;
    }

    trocarUsuario(global: MasterPageComponent) {
        let user_id: number = parseInt($('.multi-usuario').val());
        global.accountService.changeUser(user_id);
    }

    removerDevidoPropriedadeExcludente(propriedade: string): boolean {
        if (this.userService.userIsCentral())
            return false;

        try {
            return this.userService.user()[propriedade];
        } catch (e) {
            return false;
        }
    }

    whatsApp_abrir()
    {
        var url = this.settingsService.getWhatsAppWaMeSuporteUrl();
        window.open(url, '_blank');
    }

    registerObservables() {
        this.subscriptionDeslogarUsuarioEvent = this.generalSignalRService.DeslogarUsuarioEvent.subscribe(data => {
            if (this.generalSignalRService.enableSignalRLog)
                console.log('BuyerSemaforoConversorComponent.AtualizarSemaforoCotacaoEvent', data);

            if (this.isLoggingOut)
                return;

            this.isLoggingOut = true;
            this.notificationService.showWarningToastr('geral.signalr.logout', { translateMessage: true });
            this.efetuarLogout();
        });
    }
}
